import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import FilterModal from "../Filter Modal/FilterModal";

export default function DataTable_Component({
  apidata,
  columns,
  searchBy,
  totalRows,
  currentPage,
  setCurrentPage,
  rowsPerPage,
  setRowsPerPage,
  dataFilter,
  setDataFilter,
  statusFilter,
  setStatusFilter,
}) {
  const [showFilterModal, setShowFilterModal] = useState(false);

  const applyFilters = () => {
    setCurrentPage(1);
    setShowFilterModal(false);
  };

  const removeFilters = () => {
    setStatusFilter("");
    setCurrentPage(1);
    setShowFilterModal(false);
  };

  return (
    <div className="table-responsive">
      <div className="row justify-content-between mb-2">
        <div className="col-md-3 mb-2">
          <input
            type="text"
            placeholder={`Search by ${searchBy}`}
            className="form-control"
            value={dataFilter}
            onChange={(e) => {
              setDataFilter(e.target.value);
              setCurrentPage(1);
            }}
          />
        </div>
        <div className="col-md-9 mb-2">
          <button
            className="btn btn-primary"
            onClick={() => setShowFilterModal(true)}
          >
            Filter
          </button>
        </div>
      </div>
      <DataTable
        columns={columns}
        data={apidata}
        pagination
        fixedHeader
        highlightOnHover
        responsive
        paginationServer
        paginationTotalRows={totalRows}
        paginationPerPage={rowsPerPage}
        paginationRowsPerPageOptions={[5, 10, 15, 20]}
        paginationDefaultPage={currentPage}
        onChangePage={(page) => setCurrentPage(page)}
        onChangeRowsPerPage={(newPerPage) => {
          setRowsPerPage(newPerPage);
        }}
      />
      <FilterModal
        show={showFilterModal}
        onHide={() => setShowFilterModal(false)}
        statusFilter={statusFilter}
        setStatusFilter={setStatusFilter}
        applyFilters={applyFilters}
        removeFilters={removeFilters}
      />
    </div>
  );
}
